export default class extends Controller {
  static targets = ['form', 'plus', 'select', 'checkbox'];

  toggleForm() {
    this.formTarget.classList.toggle('open');
    this.plusTarget.classList.toggle('filter-close');
  }

  submitWithValues(event) {
    event.preventDefault();
    document.location = this.urlWithValues;
  }

  //
  // GETTERS AND SETTERS
  //

  get urlWithPlaceholder() {
    return this.data.get('url-with-placeholder');
  }

  get urlWithValues() {
    return this.urlWithPlaceholder.replace(/FILTER_PLACEHOLDER/g, encodeURIComponent(this.value));
  }

  get value() {
    if (this.hasCheckboxTarget) return this.checkboxValue;
    if (this.hasSelectTarget) return this.selectValue;
  }

  get checkboxValue() {
    return this.checkboxTargets.reduce((val, input) => input.checked ? [...val, input.value] : val, []);
  }

  get selectValue() {
    return App.DynamicSelect.getValue(this.selectTarget);
  }
}



// WEBPACK FOOTER //
// ./app/components/overviews/assets/javascript/overviews-filter-group-controller.js